module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "一键修改字段值",
      "prop": "field_id"
    }
  }, [_vm._l((_vm.form.modify_list), function(item, index) {
    return _c('div', [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.field_id),
        expression: "item.field_id"
      }],
      staticClass: "fl w-150 m-r-10",
      attrs: {
        "filterable": "",
        "placeholder": "字段名"
      },
      domProps: {
        "value": (item.field_id)
      },
      on: {
        "input": function($event) {
          item.field_id = $event
        }
      }
    }, _vm._l((_vm.inputList), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.default.name + '(' + option.default.title + ')',
          "value": option.default.field_id
        }
      })
    })), _vm._v(" "), _c('span', [_vm._v("修改为")]), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.type),
        expression: "item.type"
      }],
      attrs: {
        "placeholder": "请选择类型"
      },
      domProps: {
        "value": (item.type)
      },
      on: {
        "input": function($event) {
          item.type = $event
        }
      }
    }, [_c('el-option', {
      attrs: {
        "label": "常量",
        "value": 10
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "时间变量",
        "value": 20
      }
    })]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "w-200 h-40",
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDelete),
        expression: "showDelete"
      }],
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteModify(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips lh-20",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("时间变量说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，不填即当前时间")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addModify
    }
  }, [_vm._v("添加")])], true)])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcfc703e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/statusConfig.vue
// module id = 1996
// module chunks = 2